import React from "react";
import {TawreedAutoComplete, TawreedControlRenderModeWithoutNested, TawreedControlRules} from "../../../../../common/components/form";
import {AutoCompleteChangeParams, AutoCompleteSelectParams} from "primereact/autocomplete";
import {GlobalContext} from "../../../../../context";
import { DataTableFilterMatchModeType } from "primereact/datatable";
import { WalletService } from "../../../domain";
import { TopupPartnerAutocompleteItemTemplate } from "./topup-partner-autocomplete.item-template";
import { TopupPartnerDto } from "../../../domain/dtos/topup-partner";

export type TopupPartnerAutoCompleteComponentProps = {
    //
    autoCompleteValue?: TopupPartnerDto;
    autoCompleteName: string;
    autoCompleteRender: TawreedControlRenderModeWithoutNested;
    autoCompleteDisabled?: boolean;
    autoCompleteRules?: TawreedControlRules;
    autoCompleteField: string;
    operator?: DataTableFilterMatchModeType,
    autoCompleteOnSelect?(e: AutoCompleteSelectParams): void;
    autoCompleteOnChange?(e: AutoCompleteChangeParams): void;
};

export const TopupPartnerAutoCompleteComponent: React.FC<TopupPartnerAutoCompleteComponentProps> = (props) => {

    const context = React.useContext(GlobalContext);
    const service: WalletService = new WalletService();
    const search = (q: string) => {
        return service
            .searchTopupPartners(q)
            .then(res => {
                const result = [];
                if (res.data && res.data.content) {
                    result.push(...res.data.content);
                }
                return result;
            });
    };

    return (
        <TawreedAutoComplete name={props.autoCompleteName}
                             render={props.autoCompleteRender}
                             disabled={props.autoCompleteDisabled}
                             rules={props.autoCompleteRules}
                             field={props.autoCompleteField}
                             value={props.autoCompleteValue}
                             scrollHeight={'25em'}
                             onSelect={props.autoCompleteOnSelect}
                             onChange={props.autoCompleteOnChange}
                             onSearch={search}
                             itemTemplate={e => <TopupPartnerAutocompleteItemTemplate rowData={e} partnersMenu={context?.constants?.constants?.partnerTypes}/>}/>
    );
}
